import { render, staticRenderFns } from "./SidebarFilterUsedPrivilege.vue?vue&type=template&id=46d97c05&scoped=true"
import script from "./SidebarFilterUsedPrivilege.vue?vue&type=script&lang=js"
export * from "./SidebarFilterUsedPrivilege.vue?vue&type=script&lang=js"
import style0 from "./SidebarFilterUsedPrivilege.vue?vue&type=style&index=0&id=46d97c05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d97c05",
  null
  
)

export default component.exports